import styled, { css } from 'styled-components'

export default styled.div`
  display: flex;
  width: 100%;
  border: 0;
  padding: 18px 15px 17px 15px;
  justify-content: left;
  align-items: center;
  position: relative;
  margin: 15px 0;

  svg {
    fill: currentColor;
    width: 24px;
    height: 24px;
    margin-right: 15px;
    flex-shrink: 0;
    align-self: start;
  }

  button {
    text-align: center;
    letter-spacing: normal;
    position: absolute;
    right: 15px;
    background: none;
    border: 0;

    ${(props) =>
      css`
        color: currentColor;
        text-decoration: underline;
        font-family: ${props.theme.font_family};
        font-weight: ${props.theme.font_weight_bold};
        font-size: ${props.theme.font_size_base};
      `}
  }

  a {
    color: currentColor;
  }

  /* Theme specified style rules */
  ${(props) =>
    css`
      font-family: ${props.theme.font_family};
      font-weight: ${props.theme.font_weight_bold};
      font-size: ${props.theme.font_size_base};
    `}

  /* Success style rules */
  ${(props) =>
    props.kind === 'success' &&
    css`
      color: ${props.theme.tokens.color.semantic.successBase};
      background: ${props.theme.tokens.color.semantic.success};
    `}

  /* Info style rules */
  ${(props) =>
    props.kind === 'info' &&
    css`
      color: ${props.theme.tokens.color.semantic.infoBase};
      background: ${props.theme.tokens.color.semantic.info};
    `}

  /* Error style rules */
  ${(props) =>
    props.kind === 'error' &&
    css`
      color: ${props.theme.tokens.color.semantic.errorBase};
      background: ${props.theme.tokens.color.semantic.error};
    `}

  /* With close button style rules */
  ${(props) =>
    props.isCloseable &&
    css`
      padding-right: 70px;
    `}
`
